export default {
  recommendations: (state) => state.recommendations,
  recommendation: (state) => state.recommendation,
  step: (state) => state.step,
  visitedStep: (state) => state.visitedStep,
  translations: (state) => state.translations,
  testdriveResultType: (state) => state.testdriveResultType,
  testdriveResultTypes: (state) => state.testdriveResultTypes,
  exclusions: (state) => state.exclusions,
  adasmatrix: (state) => state.adasmatrix,
  adasmatrices: (state) => state.adasmatrices,
  decodedVin: (state) => state.decodedVin,
  decodedAltVin: (state) => state.decodedAltVin,
  adasmakematrices: (state) => state.adasmakematrices,
  adasmakematrix: (state) => state.adasmakematrix,
  adasmatrixinfolookups: (state) => state.adasmatrixinfolookups,
  adasmatrixinfolookup: (state) => state.adasmatrixinfolookup
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/getters.js